import React from 'react';
import styled, { css } from 'styled-components';
import { lighten } from '../../../../polished/lib';
import { colors, media } from '../../../lib/styles';
import Left1 from '../../Icon/components/Left1';
import Right1 from '../../Icon/components/Right1';

interface PaginationButtonProps {
    color?: string;
    isDisabled?: boolean;
    name?: string;
    onClick?: () => void;
    children: React.ReactNode;
}

const StyledPaginationButton = styled.button<{ disabled?: boolean; color?: string }>(
    ({ disabled = false, color = colors.grey800 }) => {
        color = disabled ? lighten(0.2, color) : color;
        return css`
            width: 70px;
            height: 70px;
            padding: 0;
            border: 3px solid ${color};
            transition: border-color 0.15s;
            border-radius: 50%;
            color: ${color};
            background-color: transparent;

            :hover {
                ${!disabled && ButtonInner} {
                    font-size: 32px;
                }
            }

            :active {
                ${!disabled && ButtonInner} {
                    font-size: 28px;
                }
            }

            :focus {
                outline: thin dotted ${colors.grey700};
            }

            @media ${media('small')} {
                width: 46px;
                height: 46px;

                :hover,
                :active {
                    ${!disabled && ButtonInner} {
                        font-size: 20px;
                    }
                }
            }
        `;
    }
);

const ButtonInner = styled.span`
    display: flex;
    justify-content: center;
    font-size: 28px;

    @media ${media('small')} {
        font-size: 20px;
    }
`;

function PaginationButton({
    isDisabled,
    color,
    name,
    onClick,
    children,
    ...props
}: PaginationButtonProps) {
    return (
        <StyledPaginationButton
            name={name}
            disabled={isDisabled}
            aria-disabled={isDisabled}
            color={color}
            onClick={onClick}
            {...props}
        >
            <ButtonInner>{children}</ButtonInner>
        </StyledPaginationButton>
    );
}

const PreviousArrow = styled(Left1)`
    margin-right: 3px;

    @media ${media('small')} {
        margin: 0;
    }
`;

const NextArrow = styled(Right1)`
    margin-left: 3px;

    @media ${media('small')} {
        margin: 0;
    }
`;

export function PrevButton({ ...props }) {
    return (
        <PaginationButton aria-label={__('previous page')} name={'previous'} {...props}>
            <PreviousArrow />
        </PaginationButton>
    );
}

export function NextButton({ ...props }) {
    return (
        <PaginationButton aria-label={__('next page')} name={'next'} {...props}>
            <NextArrow />
        </PaginationButton>
    );
}
